var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2338 36.9715L26.5497 44.9412L23.3109 44.9559L31.855 34.7765L32.3948 34.1334L31.8548 33.4904L23.3113 23.3183L26.5495 23.333L33.2335 31.3095L33.9997 32.2238L34.7662 31.3098L41.4503 23.3401L44.6826 23.3254L36.1517 33.4981L35.6128 34.1407L36.1518 34.7832L44.6896 44.9629L41.4572 44.9482L34.7662 36.9714L33.9999 36.058L33.2338 36.9715ZM34 1.5C16.0524 1.5 1.5 16.0524 1.5 34C1.5 51.9476 16.0524 66.5 34 66.5C51.9476 66.5 66.5 51.9476 66.5 34C66.5 16.0524 51.9476 1.5 34 1.5Z",
    stroke: "#FF3348",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.beaa0f5abdf25300af1f25a7f4452e4a.svg";
export { ForwardRef as ReactComponent };